import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';

interface SignupSubmitButtonProps {
  disabled?: boolean;
  loading?: boolean;
}

export const SignupSubmitButton = ({ disabled, loading }: SignupSubmitButtonProps) => {
  const { t } = useTranslation('auth');

  return (
    <button
      type="submit"
      className="btn btn-lg btn-primary signup-page__submit"
      disabled={disabled || loading}
    >
      {loading ? (
        <>
          <Loader2 className="spin" size={16} /> {t('signup.actions.submitting')}
        </>
      ) : (
        t('signup.actions.submit')
      )}
    </button>
  );
};
